import type { Memory } from '@timelyapp/integration-cloud-api-spec';
import { DateTime } from 'luxon';

type MemoryWithEndedAt = Partial<Memory> & { ended_at: string };
type FindMemoryParams = {
  /** @default true Excludes any memories that ended in the future (vs "now") */
  excludeFuture: boolean;
};
export const findLastRelevantMemoryEndedAt = (
  memories: MemoryWithEndedAt[],
  params?: FindMemoryParams
): string | null => {
  const timeNow = DateTime.now();
  const excludeFuture = params?.excludeFuture ?? true;

  const latestUpdatedMemory = memories.reduce((latest, memory) => {
    const thisMemoryEndedAt = DateTime.fromISO(memory.ended_at);
    const thisMemoryIsLatest = thisMemoryEndedAt > DateTime.fromISO(latest.ended_at);
    const thisMemoryEndedInPast = thisMemoryEndedAt < timeNow;

    if (thisMemoryIsLatest) {
      if (excludeFuture && thisMemoryEndedInPast) {
        return memory;
      } else if (!excludeFuture) {
        return memory;
      }
    }

    return latest;
  }, memories[0]);

  return latestUpdatedMemory?.ended_at || null;
};
